import React from 'react'

const Video = (props = {}) => {
    // constructor(props) {
    //   super(props);
    //   this.videoTag = React.createRef()
    // }

    const videoTag = React.createRef()

    const setStream = () => {
      if(props.stream){
          videoTag.current.srcObject = props.stream;
          if(props.muted){
            videoTag.current.muted = true;
          }
      }
    }
    
    React.useEffect(()=>{
      setStream();
    },[])

    React.useEffect(()=>{
      setStream();
    },[props.id])

    // componentDidUpdate(prevProps){
    //   if(prevProps.id !== this.props.id){
    //     this.setStream();
    //   }
    // }

    // componentDidMount() {
    //   this.setStream();
    // }

    // render() {
      return (
        <video
          // id={uniqueId}
          ref={videoTag}
          playsInline
          autoPlay
          style={props.inverse ? {transform: "scaleX(-1)"} : {}}
        />
      )
    }
// }

export default Video;
